import { BrandResp } from 'types/api/response/brand-resp'

import { api } from './api'

export const getBrandById = (brandId: number) => api.get<BrandResp>(`/brands/${brandId}`)
